import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareInfoSolid = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 3V21H21V3H3ZM10 10.25H12.75L12.75 17L11.25 17L11.25 11.75H10V10.25ZM12.75 7.25H11.25V8.75H12.75V7.25Z",
		fill: "currentColor"
	})]
});
export default SvgSquareInfoSolid;
